import React, { PureComponent } from "react";
import { Column, InputWrapper } from "../ProfilePage.styles";
import withServices from "src/HOCs/withServices";
import { SOCKET } from "src/common/constants";
import { toast } from "react-toastify";
import { decodeSocketMessage } from "src/common/utils";

interface Props {
  services: any;
  isStudent: boolean;
}

interface State {
  assessmentsBreakdown: [];
  selectedAssessment: string;
  sid: string;
  loading: boolean;
}

class DownloadLeanerReport extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      assessmentsBreakdown: [],
      selectedAssessment: "",
      sid: "",
      loading: false,
    };
  }

  public async componentDidMount() {
    console.log(this.props);
    const {
      services: { studentsAPI, currentUserID },
      isStudent,
    } = this.props;

    SOCKET.connect();

    SOCKET.on("connect", this.onSocketConnect);

    SOCKET.on("customEmit", (data) => this.onSetup(data));

    SOCKET.on("customNotif", (data) => this.onMessage(data));

    SOCKET.emit("customMsg", { evt: "init" });

    const assessmentRes = await studentsAPI.getLearnerAssessments(
      currentUserID
    );

    if (assessmentRes.ok) {
      const filteredAssessments = assessmentRes.data.breakdown.assessments.filter((assessment: any) => !assessment.title.includes("Trusted Adult"));
      this.setState({
        assessmentsBreakdown: filteredAssessments,
      });
    }
  }

  public onSocketConnect = () => {
    console.log("connected");
  };

  public onMessage(socketResponse) {
    const socketMessage = decodeSocketMessage(socketResponse);
    this.setState({ loading: false });
    const link = socketMessage.message.data.link;

    console.log({ socketMessage });

    if (socketMessage.message.status === "failed") {
      toast.error(
        "Ooops, the report could not be generated: " +
        socketMessage.message.data.final_status
      );
      return;
    }

    window.open(link, "_blank");
  }

  public onSetup = (message) => {
    this.setState({ sid: message.id });
  };

  public handleAssessmentSelect = (event) => {
    this.setState({ selectedAssessment: event.target.value });
  };

  public downloadLearnerReport = async () => {
    const { selectedAssessment } = this.state;
    console.log("download...");
    const socketId = sessionStorage.getItem("socketId");
    console.log({ socketId });

    if (!socketId) {
      toast.error(
        "There is an issue with the report generation, please reload the page and try again."
      );
      window.location.reload();
      return;
    }

    const downloadRes =
      await this.props.services.studentsAPI.downloadLearnerReport(
        selectedAssessment,
        socketId
      );

    if (downloadRes.ok) {
      toast.success("Great! You will have your reports in a second!");
    } else {
      toast.error("Ooops, the report could not be generated, try again.");
    }
  };

  public render() {
    const { assessmentsBreakdown } = this.state;
    return (
      <Column width="100%" height="200px" background={true}>
        <h1 className="details-heading" style={{ marginTop: "-1.5em" }}>
          Download your report
        </h1>
        <InputWrapper>
          <p>Pick an assessment </p>
          <select
            className="custom-select"
            placeholder="Enter your current password"
            required={true}
            data-arg="current-pass"
            onChange={this.handleAssessmentSelect}
          >
            <option value="">Pick an assessment</option>
            {assessmentsBreakdown.map((a: any) => (
              <option value={a.id} key={a.Title + a.id}>
                {a.title}
              </option>
            ))}
          </select>
        </InputWrapper>

        <button
          className="green-button update-details"
          onClick={this.downloadLearnerReport}
        >
          Download Now
        </button>
      </Column>
    );
  }
}

export default withServices(DownloadLeanerReport);



// WEBPACK FOOTER //
// ./src/pages/Profile/Student/DownloadLeanerReport.Component.tsx